import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useState, useEffect } from 'react';
import CustomAutoComplete from './CustomAutoComplete';
import { Checkbox, Chip, CircularProgress, FormControlLabel, Paper, Stack } from '@mui/material';
import DatePick from './DatePick';
import AutoCompleteBank from './AutoCompleteBank';
import CustomTableOrder from './CustomTableOrder';
import PickProduct from '../pages/Order/PickProduct';
import API from '../services/api';
import { Add, ArrowBackIosNew, ArrowForwardIos, Discount, InfoOutlined, Send } from '@mui/icons-material';
import PickPromotion from '../pages/Order/PickPromotion';
import TextArea from './TextArea'
import OrderSummary from './OrderSummary';
import CustomSnackBar from './CustomSnackBar';
import GeneratePDFButtons from './pdf/ButtonOrderPDF';
import RefreshButtonSpinner from './RefreshButtonSpinner';
import { useCallback } from 'react';
import CustomModal from './CustomModal';
import SuccessMessage from './SuccessMessage';




const steps = ['Ingreso información del proveedor', 'Agregar productos', 'Confirmar', 'Finalizar orden de compra'];



export default function CustomStepper({ order, setOrder, setNameSupplier, flow, setFlowField, resetFlow }) {
  const [activeStepLocal, setActiveStepLocal] = React.useState(0);
  const [completedLocal, setCompletedLocal] = React.useState({});
  const [open, setOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [selectedProductsLocal, setSelectedProductsLocal] = React.useState([]);
  const [orderDetailsLocal, setOrderDetailsLocal] = React.useState([]);

  /*Para snackBar */
  const [openSnack, setOpenSnack] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackMessage, setSnackMessage] = useState('');
  const [snackSeverity, setSnackSeverity] = useState('info');
  /*------------------------------------------------------------- */

  const [openPromotionModal, setOpenPromotionModal] = useState(false);
  const [warehouses, setWarehouses] = useState([]);
  const [selectedPromotions, setSelectedPromotions] = useState([]);
  const [currentOrderDetailIndex, setCurrentOrderDetailIndex] = useState(null);
  const [supplierAllProducts, setSupplierAllProducts] = useState(false);
  const [pendingOrderContext, setPendingOrderContext] = useState({
    summary: {
      active_orders: 0,
      orders_with_pending: 0,
      pending_products: 0,
      total_pending_quantity: 0,
    },
    orders: [],
    products: [],
  });
  const [pendingContextLoading, setPendingContextLoading] = useState(false);
  const [pendingSelectedOrderIds, setPendingSelectedOrderIds] = useState([]);

  const activeStep = flow?.activeStep ?? activeStepLocal;
  const completed = flow?.completed ?? completedLocal;
  const selectedProducts = flow?.selectedProducts ?? selectedProductsLocal;
  const orderDetails = flow?.orderDetails ?? orderDetailsLocal;
  const safeOrderDetails = Array.isArray(orderDetails) ? orderDetails : [];
  const orderProductIdSet = React.useMemo(() => {
    return new Set(
      safeOrderDetails
        .map((d) => Number(d?.product_id || d?.product?.id))
        .filter((id) => Number.isFinite(id))
    );
  }, [safeOrderDetails]);
  const orderBonusProductIdSet = React.useMemo(() => {
    return new Set(
      (order?.order_bonus || [])
        .map((b) => Number(b?.product_id || b?.product?.id))
        .filter((id) => Number.isFinite(id))
    );
  }, [order?.order_bonus]);
  const productsForModal = React.useMemo(() => {
    return (products || []).filter((p) => !orderProductIdSet.has(Number(p?.id)));
  }, [products, orderProductIdSet]);
  const topPendingOrders = React.useMemo(() => {
    return (pendingOrderContext?.orders || []).slice(0, 8);
  }, [pendingOrderContext]);
  const pendingSelectedOrderSet = React.useMemo(() => (
    new Set((pendingSelectedOrderIds || []).map((id) => Number(id)))
  ), [pendingSelectedOrderIds]);
  const selectedPendingProductsContext = React.useMemo(() => {
    if (!pendingSelectedOrderSet.size) return [];
    return (pendingOrderContext?.products || [])
      .map((ctx) => {
        const selectedOrders = (ctx?.by_order || []).filter((orderRow) =>
          pendingSelectedOrderSet.has(Number(orderRow?.order_id))
        );
        const consolidated = selectedOrders.reduce(
          (sum, row) => sum + Number(row?.pending_quantity || 0),
          0
        );
        if (consolidated <= 0) return null;
        const formatSet = new Set();
        selectedOrders.forEach((orderRow) => {
          (orderRow?.details || []).forEach((detail) => {
            if (detail?.format) formatSet.add(detail.format);
          });
        });
        return {
          ...ctx,
          by_order: selectedOrders,
          consolidated_pending_quantity: consolidated,
          pending_orders_count: selectedOrders.length,
          formats: Array.from(formatSet),
        };
      })
      .filter(Boolean);
  }, [pendingOrderContext?.products, pendingSelectedOrderSet]);

  const setActiveStep = (val) => {
    const v = typeof val === 'function' ? val(activeStep) : val;
    if (setFlowField) setFlowField('activeStep', v);
    else setActiveStepLocal(v);
  };
  const setCompleted = (val) => {
    const v = typeof val === 'function' ? val(completed) : val;
    if (setFlowField) setFlowField('completed', v);
    else setCompletedLocal(v);
  };
  const setSelectedProducts = (val) => {
    const v = typeof val === 'function' ? val(selectedProducts) : val;
    if (setFlowField) setFlowField('selectedProducts', v);
    else setSelectedProductsLocal(v);
  };
  const setOrderDetails = (val) => {
    const v = typeof val === 'function' ? val(orderDetails) : val;
    if (setFlowField) setFlowField('orderDetails', v);
    else setOrderDetailsLocal(v);
  };

  const totalSteps = () => steps.length;
  const completedSteps = () => Object.keys(completed).length;
  const isLastStep = () => activeStep === totalSteps() - 1;
  const allStepsCompleted = () => completedSteps() === totalSteps();


  const handleChange = (name, value) => {
    setOrder({ ...order, [name]: value });
  };

  const handleSelectChange = (name, value) => { if (name === 'storage') { setOrder(prev => ({ ...prev, storage: value ? value.name : '', warehouse_id: value ? value.id : null, })); return; } setOrder(prevState => ({ ...prevState, [name]: value })); };

  const getProductData = async () => {
    if (!order.supplier_id || supplierAllProducts) {
      setProducts([]);
      return;
    }
    try {
      const response = await API.post('product/getProductsBySupplier/', { supplier_id: order.supplier_id });
      const productsWithIsAdd = response.data.map(product => ({
        ...product,
        isAdd: false,
      }));
      setProducts(productsWithIsAdd);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (order.supplier_id !== 0 && !supplierAllProducts) {
      getProductData();
      return;
    }
    if (order.supplier_id !== 0 && supplierAllProducts) {
      setProducts([]);
    }
  }, [order.supplier_id, supplierAllProducts]);

  useEffect(() => {
    if (!order.supplier_id) {
      setSupplierAllProducts(false);
      setProducts([]);
      setPendingOrderContext({
        summary: {
          active_orders: 0,
          orders_with_pending: 0,
          pending_products: 0,
          total_pending_quantity: 0,
        },
        orders: [],
        products: [],
      });
      setPendingSelectedOrderIds([]);
    }
  }, [order.supplier_id]);

  useEffect(() => {
    if (!order.supplier_id) {
      setPendingContextLoading(false);
      return;
    }

    let mounted = true;
    setPendingContextLoading(true);

    (async () => {
      try {
        const { data } = await API.get('order-Av/pending_order_context/', {
          params: { supplier_id: order.supplier_id },
        });
        if (!mounted) return;
        setPendingOrderContext({
          summary: data?.summary || {
            active_orders: 0,
            orders_with_pending: 0,
            pending_products: 0,
            total_pending_quantity: 0,
          },
          orders: Array.isArray(data?.orders) ? data.orders : [],
          products: Array.isArray(data?.products) ? data.products : [],
        });
        setPendingSelectedOrderIds([]);
      } catch (error) {
        if (!mounted) return;
        console.error('No se pudo cargar el contexto de pendientes', error);
        setPendingOrderContext({
          summary: {
            active_orders: 0,
            orders_with_pending: 0,
            pending_products: 0,
            total_pending_quantity: 0,
          },
          orders: [],
          products: [],
        });
        setPendingSelectedOrderIds([]);
      } finally {
        if (mounted) setPendingContextLoading(false);
      }
    })();

    return () => { mounted = false; };
  }, [order.supplier_id]);
  const handleTogglePendingOrder = (orderId) => {
    setPendingSelectedOrderIds((prev) => {
      const normalizedId = Number(orderId);
      if (!Number.isFinite(normalizedId)) return prev;
      if (prev.includes(normalizedId)) {
        return prev.filter((id) => id !== normalizedId);
      }
      return [...prev, normalizedId];
    });
  };
  const handleSelectAllPendingOrders = () => {
    const allIds = (pendingOrderContext?.orders || [])
      .map((row) => Number(row?.order_id))
      .filter((id) => Number.isFinite(id));
    setPendingSelectedOrderIds(allIds);
  };
  const handleClearPendingOrdersSelection = () => {
    setPendingSelectedOrderIds([]);
  };

  useEffect(() => {
    if (!selectedProducts.length) return;
    setSelectedProducts((prev) => prev.filter((p) => !orderProductIdSet.has(Number(p?.id))));
  }, [orderProductIdSet, selectedProducts.length]);


  useEffect(() => {
    const stepCompleted = isStepComplete();
    if (completed[activeStep] !== stepCompleted) {
      setCompleted(prev => ({
        ...prev,
        [activeStep]: stepCompleted
      }));
    }
  }, [order, selectedProducts, activeStep]);


  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await API.get('catalogs/create_order/');
        const ws = Array.isArray(data?.warehouses) ? data.warehouses : [];
        if (mounted) setWarehouses(ws);
      } catch { if (mounted) setWarehouses([]); }
    })();
    return () => { mounted = false; };
  }, []);
  const addToOrderDetails = (selectedProducts) => {
    if (selectedProducts.length === 0) return;
    console.log('productos seleccionados' + selectedProducts)

    const newOrderDetails = selectedProducts.map((product) => ({
      product_id: product.id,
      code: product.code,
      description: product.description || [],
      quantity: 1,
      prformat: product.prformat || null,
      prformat_id: product.prformat_id || product.prformat?.id || null,
      listPrice: product.prices[0]?.price || 0,
      finalPrice: product.prices[0]?.price || 0,
      bonusPrice: 0,
      prices: product.prices,
    }));

    setOrderDetails((prevOrderDetails) => [...prevOrderDetails, ...newOrderDetails]);
    console.log('Agregando a orderDetails:', selectedProducts);
  };

  // En tu handleAddPromotionsToOrder
  const handleAddPromotionsToOrder = () => {
    if (selectedPromotions.length === 0) return;

    const freshPromos = selectedPromotions.filter((p) => !orderBonusProductIdSet.has(Number(p?.id)));
    if (freshPromos.length === 0) {
      setOpenSnack(true);
      setSnackMessage('La promoción ya fue agregada');
      setSnackSeverity('warning');
      return;
    }
    if (freshPromos.length < selectedPromotions.length) {
      setOpenSnack(true);
      setSnackMessage('Se omitieron promociones duplicadas');
      setSnackSeverity('warning');
    }

    // Crear bonificaciones según el nuevo modelo OrderBonus
    const newBonuses = freshPromos.map(product => ({
      product_id: product.id,
      description: product.description,
      code: product.code,
      quantity: 1,
      prformat: product.prformat,
      prformat_id: product.prformat_id || product.prformat?.id || null,
      reason: null,
      source_product_id: currentOrderDetailIndex !== null ?
        orderDetails[currentOrderDetailIndex]?.product_id : null
    }));

    // Actualizar el estado de la orden
      setOrder(prevOrder => ({
        ...prevOrder,
        order_bonus: [...(prevOrder.order_bonus || []), ...newBonuses]
      }));

    setSelectedPromotions([]);
    setOpenPromotionModal(false);
  };

  const handleAddToCart = () => {
    console.log("Antes de agregar, selectedProducts:", selectedProducts);

    if (selectedProducts.length === 0) {
      console.warn("No hay productos seleccionados para agregar.");
      return;
    }

    const freshProducts = selectedProducts.filter((p) => !orderProductIdSet.has(Number(p?.id)));
    if (freshProducts.length === 0) {
      setOpenSnack(true);
      setSnackMessage('El producto ya fue agregado');
      setSnackSeverity('warning');
      return;
    }
    if (freshProducts.length < selectedProducts.length) {
      setOpenSnack(true);
      setSnackMessage('Se omitieron productos duplicados');
      setSnackSeverity('warning');
    }

    addToOrderDetails(freshProducts);
    console.log("Después de agregar a OrderDetails");

    const updatedProducts = products.map((product) =>
      freshProducts.some((p) => p.id === product.id)
        ? { ...product, isAdd: true }
        : product
    );

    setProducts(updatedProducts);
    setSelectedProducts([]);
    setOpen(false);
  };


  const handleNext = async () => {
    if (!isStepComplete()) {
      return;
    }

    if (activeStep === 1) {
      setOrder((prevOrder) => ({
        ...prevOrder,
        order_details: orderDetails,
      }));
    }

    // Si es el penúltimo paso (confirmación)
    if (activeStep === steps.length - 2) {
      const success = await handleComplete();
      if (success) {
        setActiveStep(activeStep + 1); // Solo avanza si fue exitoso
      }
      return;
    }

    // Para otros pasos
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;

    setActiveStep(newActiveStep);
  };


  const handleBack = () => {
    if (completed[activeStep]) return;
    setActiveStep(prevActiveStep => prevActiveStep - 1);

  };

  const handleComplete = async () => {
    try {
      setLoading(true);
      const response = await API.post('order/createOrder/', order);
      console.log('Orden creada:', response.data);
      setOrder(response.data.order);
      setCompleted({
        ...completed,
        [activeStep]: true,
      });
      setOpenSnack(true);
      setSnackMessage('¡Creado con éxito!');
      setSnackSeverity('success');
      return true;
    } catch (error) {
      console.error('Error al crear la orden:', error);
      setOpenSnack(true);
      setSnackMessage('Algo salió mal, intente de nuevo: ' + error.message);
      setSnackSeverity('error');
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
    setOrder({
      dateTime: '',
      comment: '',
      total: 0,
      currency: 'Q',
      storage: '',
      commentSupplier: '',
      supplier_id: 0,
      order_details: [],
    });
    setSelectedProducts([]);
    setOrderDetails([]);
    resetFlow && resetFlow();
  };

  const isStepComplete = useCallback(() => {
    switch (activeStep) {
      case 0:
        return order.supplier_id !== 0 && order.dateTime !== '' && order.storage !== '';
      case 1:
        return orderDetails.length > 0;
      case 2:
        return order.commentSupplier !== '';
      case 3:
        return true;
      default:
        return false;
    }
  }, [order.commentSupplier, activeStep, orderDetails, order.supplier_id, order.dateTime, order.storage]);


  const getStorageValue = () => {
    if (!order) return null;
    if (order.warehouse_id) {
      return warehouses.find(w => String(w.id) === String(order.warehouse_id)) || null;
    }
    if (order.storage) {
      return warehouses.find(w => w.name === order.storage) || null;
    }
    return null;
  };


  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Box sx={{ marginTop: '15px' }}>
            <CustomAutoComplete
              name={'supplier_id'}
              supplier={order.supplier_id}
              onChange={handleChange}
              setSupplierName={setNameSupplier}
              endpoint="suppliers/minimal/"
              onSelectOption={(supplier) => setSupplierAllProducts(Boolean(supplier?.all_products))}
            />

            <Stack spacing={2} direction={{ sx: 'column', sm: 'row' }}>
              <DatePick
                label='Fecha de entrega'
                name={'dateTime'}
                value={order.dateTime}
                onChange={handleChange}
                returnType='iso'
                defaultToday={false}
              />
              <AutoCompleteBank
                options={warehouses}
                getOptionLabel={(w) => w.name}
                size='medium'
                label='Bodega de entrega'
                onChange={handleSelectChange}
                name={'storage'}
                value={getStorageValue()}
              />
            </Stack>
          </Box>
        );
      case 1:
        return (
          <>
            {order?.supplier_id ? (
              <Paper
                variant="outlined"
                sx={{ mb: 1.25, px: 1.5, py: 1.1, borderColor: 'divider', bgcolor: 'background.paper' }}
              >
                <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1 }}>
                  <Box sx={{ minWidth: 0 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.7, fontWeight: 600 }}
                    >
                      <InfoOutlined sx={{ fontSize: 17, color: 'text.secondary' }} />
                      Contexto de órdenes pendientes
                    </Typography>
                    <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', mt: 0.25 }}>
                      Referencia automática para evitar pedidos repetidos. No se importa ni bloquea cantidades.
                    </Typography>
                  </Box>

                  {pendingContextLoading ? <CircularProgress size={16} /> : null}
                </Box>

                {!pendingContextLoading ? (
                  Number(pendingOrderContext?.summary?.orders_with_pending || 0) > 0 ? (
                    <Box sx={{ mt: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, flexWrap: 'wrap' }}>
                        <Chip
                          size="small"
                          label={`${Number(pendingOrderContext?.summary?.orders_with_pending || 0)} OC con pendiente`}
                        />
                        <Chip
                          size="small"
                          label={`${Number(pendingOrderContext?.summary?.pending_products || 0)} productos pendientes`}
                        />
                        <Chip
                          size="small"
                          color="warning"
                          variant="outlined"
                          label={`${Number(pendingOrderContext?.summary?.total_pending_quantity || 0).toLocaleString('es-GT')} unidades pendientes`}
                        />
                        <Chip
                          size="small"
                          color={pendingSelectedOrderIds.length > 0 ? 'primary' : 'default'}
                          variant={pendingSelectedOrderIds.length > 0 ? 'filled' : 'outlined'}
                          label={
                            pendingSelectedOrderIds.length > 0
                              ? `${pendingSelectedOrderIds.length} OC tomadas en cuenta`
                              : 'Sin OC tomadas en cuenta'
                          }
                        />
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={handleSelectAllPendingOrders}
                          sx={{ textTransform: 'none', fontSize: '0.72rem', minHeight: 26, px: 1 }}
                        >
                          Tomar en cuenta esta data
                        </Button>
                        {pendingSelectedOrderIds.length > 0 ? (
                          <Button
                            size="small"
                            color="inherit"
                            onClick={handleClearPendingOrdersSelection}
                            sx={{ textTransform: 'none', fontSize: '0.72rem', minHeight: 26, px: 1 }}
                          >
                            Limpiar selección
                          </Button>
                        ) : null}
                      </Box>

                      <Box sx={{ mt: 0.8, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                        {topPendingOrders.map((row) => {
                          const selected = pendingSelectedOrderSet.has(Number(row.order_id));
                          const createdDate = row?.created_at
                            ? new Date(row.created_at).toLocaleDateString('es-GT')
                            : '-';
                          return (
                            <FormControlLabel
                              key={row.order_id}
                              control={(
                                <Checkbox
                                  checked={selected}
                                  onChange={() => handleTogglePendingOrder(row.order_id)}
                                  size="small"
                                />
                              )}
                              sx={{ m: 0, '& .MuiFormControlLabel-label': { width: '100%' } }}
                              label={(
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', pr: 1 }}>
                                  <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                    {`${row.order_code || `OC #${row.order_id}`} · ${createdDate}`}
                                  </Typography>
                                  <Typography variant="caption" sx={{ fontWeight: 600 }}>
                                    {`${Number(row.pending_quantity || 0).toLocaleString('es-GT')} por despachar`}
                                  </Typography>
                                </Box>
                              )}
                            />
                          );
                        })}
                        {Number((pendingOrderContext?.orders || []).length) > topPendingOrders.length ? (
                          <Typography variant="caption" sx={{ color: 'text.secondary', pl: 1 }}>
                            +{Number((pendingOrderContext?.orders || []).length) - topPendingOrders.length} OC más disponibles
                          </Typography>
                        ) : null}
                      </Box>
                    </Box>
                  ) : (
                    <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', mt: 0.75 }}>
                      No se detectaron pendientes vigentes para este proveedor.
                    </Typography>
                  )
                ) : null}
              </Paper>
            ) : null}

            <CustomTableOrder
              setOpen={setOpen}
              orderDetails={orderDetails}
              setOrderDetails={setOrderDetails}
              products={products}
              setProducts={setProducts}
              setOpenPromotionModal={setOpenPromotionModal}
              setCurrentOrderDetailIndex={setCurrentOrderDetailIndex}
              order={order}
              setOrder={setOrder}
              pendingProductsContext={selectedPendingProductsContext}
            />

            <CustomModal
              open={open}
              setOpen={setOpen}
              handleClose={() => setOpen(false)}
              component={PickProduct}
              width='70%'
              title='Agregar productos'
              icon={Add}
              componentProps={{
                setOpen,
                products: productsForModal,
                selectedProducts,
                setSelectedProducts,
                updateProducts: setProducts,
                handleAddToCart,
                excludedProductIds: orderProductIdSet,
                supplierId: order.supplier_id,
                allProducts: supplierAllProducts,
              }}
            />


            <CustomModal
              open={openPromotionModal}
              setOpen={setOpenPromotionModal}
              handleClose={() => setOpenPromotionModal(false)}
              component={PickPromotion}
              width='70%'
              title='Agregar promoción'
              icon={Discount}
              headerColor='succcess'
              headerBgColor={'success.main'}
              componentProps={{
                products,
                selectedPromotions,
                setSelectedPromotions,
                handleAddPromotions: handleAddPromotionsToOrder,
                excludedProductIds: orderBonusProductIdSet,
              }}
            />
          </>
        );
      case 2:
        return (
          <>
            <OrderSummary order={order} orderDetails={orderDetails} orderBonus={order.order_bonus} />
            <Stack spacing={2} sx={{ marginTop: '20px' }} direction={{ sx: 'column', sm: 'row' }}>
              <TextArea
                label='Comentario para el proveedor'
                onChange={handleChange}
                name={'commentSupplier'}
                newValue={order.commentSupplier}
              />
              <TextArea
                label='Comentario interno'
                onChange={handleChange}
                name={'comment'}
                newValue={order.comment}
              />
            </Stack>
          </>
        );
      case 3:
        const canGeneratePDF = order?.order_details?.every(detail =>
          detail?.quantity && detail?.product?.description
        );
        return (
          <>
            <SuccessMessage
              onNewInvoice={handleReset}
              buttonText='Ingresar nueva orden'
              success='¡Orden creada con éxito!'
              subtitle='Puedes ver las ordenes desde la opción de listado'
              error={canGeneratePDF ? undefined : 'No se pudo generar el PDF'}
            />
            {canGeneratePDF && (
              <GeneratePDFButtons
                order={{
                  ...order,
                  order_details: order.order_details.map(detail => ({
                    ...detail,
                    product: {
                      ...detail.product,
                      description: detail.product?.description || 'Sin descripción'
                    }
                  }))
                }}
              />
            )}
          </>
        );

      default:
        return <Typography variant="h6">Paso no encontrado</Typography>;
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          width: '100%',
          overflowX: 'auto',
          overflowY: 'hidden',
          pb: 0.5,
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
        }}
      >
        <Stepper nonLinear activeStep={activeStep} sx={{ width: 'max-content', minWidth: '100%', px: 0.3, '& .MuiStep-root': { flexShrink: 0 }, '& .MuiStepConnector-line': { minHeight: 2 }, }}>
          {steps.map((label, index) => (
            <Step key={label} completed={completed[index]}>
              <StepButton
                color="inherit"
                disabled={completed[index]}
              >
                {completed[index] ? (
                  <Typography variant='subtitle1'>Completado</Typography>
                ) : (
                  label
                )}
              </StepButton>
            </Step>
          ))}
        </Stepper>
      </Box>
      <div>
        {activeStep === steps.length - 1 ? (
          getStepContent(activeStep)
        ) : allStepsCompleted() ? (
          <React.Fragment>
            <Typography sx={{ mt: 2, mb: 1 }}>
              Todos los pasos completados - ¡estás terminado!
            </Typography>
          </React.Fragment>
        ) : (
          <>
            {getStepContent(activeStep)}
            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <RefreshButtonSpinner
                onClick={handleReset}
              />
              <Button
                color="inherit"
                size='small'
                disabled={activeStep === 0 || completed[activeStep]}
                onClick={handleBack}
                startIcon={<ArrowBackIosNew />}
                sx={{
                  mr: 1,
                  ml: 2,
                  textTransform: 'none',
                  borderRadius: 1,
                  fontSize: '0.8rem',
                  color: 'text.primary',
                  borderColor: 'divider',
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                  },
                }}>

                Atrás
              </Button>
              <Box sx={{ flex: '1 1 auto' }} />
              <Button
                onClick={activeStep === steps.length - 1 ? handleComplete : handleNext}
                size='small'
                sx={{
                  mr: 1,
                  textTransform: 'none',
                  borderRadius: 1,
                  px: 2.5,
                  fontSize: '0.8rem',
                  backgroundColor: isStepComplete() && !loading ? 'primary.main' : 'transparent',
                  color: isStepComplete() && !loading ? '#fff' : 'text.disabled',
                  border: '1px solid',
                  borderColor: isStepComplete() && !loading ? 'primary.main' : 'divider',
                  cursor: isStepComplete() && !loading ? 'pointer' : 'not-allowed',
                  '&:hover': {
                    backgroundColor: isStepComplete() && !loading ? '#1c2559' : 'transparent',
                  },
                }}
                disabled={!isStepComplete() || loading}
                endIcon={activeStep === steps.length - 2 ? <Send /> : <ArrowForwardIos />}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  activeStep === steps.length - 2 ? "Finalizar" : "Siguiente"
                )}
              </Button>
            </Box>
          </>
        )}
      </div>
      {openSnack && (
        <CustomSnackBar open={openSnack} setOpen={setOpenSnack} message={snackMessage} severity={snackSeverity} />
      )}
    </Box>

  );
}







